import { api } from './client';

export interface Session {
  isReviewer: boolean;
  isAdmin: boolean;
  pendingReviewCount: number;
  /** The viewer's own Entra object id (#222) — lets the client tell its own
   * requests apart from someone else's, e.g. RequestForm's read-only gate. */
  aadId: string;
}

export const getSession = (): Promise<Session> => api<Session>('/api/session');
